var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask", attrs: { id: _vm.id } }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-dialog modal-container" }, [
          _c("div", { staticClass: "modal-content" }, [
            !_vm.hideHeader
              ? _c(
                  "div",
                  { staticClass: "modal-header" },
                  [
                    _vm._t("modal-header", [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.title) +
                            "\n              "
                        )
                      ])
                    ])
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "modal-subheader" }, slot: "modal-subheader" },
              [_vm._t("modal-subheader")],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            !_vm.isHideFooter
              ? _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    !_vm.isCustomFooter
                      ? _vm._t("modal-footer", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("cancel")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.closeTitle || _vm.$t("common.cancel")
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                disabled: _vm.okDisabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("ok")
                                }
                              }
                            },
                            [
                              !_vm.okBusy
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.okTitle || _vm.$t("common.confirm")
                                      )
                                    )
                                  ])
                                : _c("LoadingBounce")
                            ],
                            1
                          )
                        ])
                      : _vm._t("modal-footer")
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1906fdbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1906fdbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomModal.vue
// module id = V6Px
// module chunks = 1